<template>
  <!-- Файл счёта / КП для формы заявки: выбор по клику или перетаскиванием.
       slim — строка списка «Дополнительно», без slim — крупная карточка
       (расчёт по КП, где документ главное). Проверку формата и размера
       делает форма (событие pick) -->
  <div v-if="file" class="app-file" :class="slim && 'app-file_slim'">
    <span class="app-file__icon" aria-hidden="true">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" /><path d="M14 3v5h5" /></svg>
    </span>
    <span class="app-file__name">
      <b>{{ file.name }}</b>
      <small>{{ size }}</small>
    </span>
    <button
      type="button"
      class="app-file__remove"
      aria-label="Удалить файл"
      title="Удалить файл"
      @click="$emit('remove')"
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18" /></svg>
    </button>
  </div>

  <label
    v-else
    class="app-drop"
    :class="[slim && 'app-drop_slim', over && 'is-over', error && 'has-error']"
    @dragover.prevent="over = true"
    @dragleave="over = false"
    @drop.prevent="onDrop"
  >
    <input
      type="file"
      class="d-none"
      accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"
      @change="onChange"
    />
    <span class="app-drop__icon" aria-hidden="true">
      <!-- скрепка в строке списка, стрелка загрузки в карточке -->
      <svg v-if="slim" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5l-8.6 8.6a5 5 0 0 1-7.1-7.1l8.6-8.6a3.3 3.3 0 0 1 4.7 4.7l-8.6 8.6a1.7 1.7 0 0 1-2.4-2.4l8-8" /></svg>
      <svg v-else width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16V4M7 9l5-5 5 5" /><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3" /></svg>
    </span>
    <span class="app-drop__text">
      <b>{{ title }}</b>
      <small
        >Перетащите сюда или <u>выберите</u> · PDF, фото, Word, Excel до 10
        МБ</small
      >
    </span>
  </label>
</template>

<script>
export default {
  name: "FilePicker",
  props: {
    file: { type: Object, default: null },
    title: { type: String, default: "Приложить счёт или КП" },
    error: { type: String, default: "" },
    slim: Boolean,
  },
  emits: ["pick", "remove"],
  data() {
    return {
      // файл перетаскивают над полем
      over: false,
    };
  },
  computed: {
    size() {
      const size = this.file ? this.file.size : 0;
      return size < 1024 * 1024
        ? Math.max(1, Math.round(size / 1024)) + " КБ"
        : (size / 1024 / 1024).toFixed(1).replace(".", ",") + " МБ";
    },
  },
  methods: {
    onChange(event) {
      const file = event.target.files[0];
      event.target.value = "";
      if (file) this.$emit("pick", file);
    },
    onDrop(event) {
      this.over = false;
      const file = event.dataTransfer.files[0];
      if (file) this.$emit("pick", file);
    },
  },
};
</script>
